<template>
  <div class="simpleDescription">
    <div class="simpleDescription-content">
      <h2>街コンジャパンとは</h2>
      <p>
        街コンジャパンは、日本最大級の街コン・パーティー情報の総合ポータルサイトです。東京、大阪、名古屋をはじめ日本全国のイベント情報の検索から参加申し込みまで、あなたの出会いを全力でサポートします。2015年4月にマザーズに上場した株式会社リンクバル（現：東証グロース）が運営しているため、安心してイベントにご参加いただけます。街コン、恋活・婚活パーティー、趣味コンはもちろん、合コン形式の少人数イベントまで、あなたにピッタリのイベントが、いつでも簡単に探せます。
      </p>
    </div>
  </div>
</template>

<script>
import { CACHE_MACHICON_DESCRIPTION } from '@/utils/constants/serverCaching'
export default {
  name: CACHE_MACHICON_DESCRIPTION.name,
  serverCacheKey() {
    return Math.floor(Date.now() / CACHE_MACHICON_DESCRIPTION.time)
  }
}
</script>

<style scoped lang="scss">
.simpleDescription {
  padding: 1.5rem 3rem 1.6rem;
  background: $white;
  color: $gray-55;
  @include sp {
    padding: 1.6rem;
    margin-top: 0;
    border-top: none;
  }
  &-content {
    font-size: 1.2rem;
    @include contentInner;
  }
}
</style>
